// extracted by mini-css-extract-plugin
export var actions = "_1c-0";
export var actionsContainer = "_1c-7";
export var border = "_1c-1";
export var childFullHeight = "_1c-f";
export var collapse = "_1c-2";
export var content = "_1c-a";
export var contentChild = "_1c-e";
export var fullscreen = "_1c-c";
export var hasLeftRadius = "_1c-k";
export var headerContainer = "_1c-3";
export var headerRow = "_1c-5";
export var hidePadding = "_1c-b";
export var navCollapsedGap = "_1c-l";
export var noScrollX = "_1c-m";
export var noScrollY = "_1c-n";
export var noTopPadding = "_1c-i";
export var optOutTopPadding = "_1c-d";
export var pageMain = "_1c-j";
export var pageOuter = "_1c-g";
export var pagePadding = "_1c-8";
export var pageScroll = "_1c-9";
export var profile = "_1c-o";
export var profileContainer = "_1c-p";
export var profileImage = "_1c-q";
export var profileMain = "_1c-r";
export var profileSubtitle = "_1c-t";
export var profileTitle = "_1c-s";
export var showLeftPadding = "_1c-h";
export var tabsPortalSlot = "_1c-6";
export var tabsWrapper = "_1c-4";
export var title = "_1c-u";